import { ApryseSDK } from '../../pdf/ApryseSDK';
import { GlobalVariables } from '../../pdf/GlobalVariables';
import Command from './_Command';

export default class ZoomController extends Command {
    constructor(
        private readonly scale: number | 'fitPage' | 'fitWidth',
        readonly Path: string | false,
    ) {
        const key = `zoomController-${scale}`;
        GlobalVariables.registeredCommands[key] = () => {
            if (typeof scale === 'number') {
                if (Number.isNaN(scale) || scale < 0) {
                    return Promise.resolve();
                }

                return GlobalVariables.zoom(scale);
            }

            if (scale === 'fitPage') {
                return ApryseSDK.documentViewer.setFitMode(
                    ApryseSDK.documentViewer.FitMode.FitPage,
                );
            }

            return ApryseSDK.documentViewer.setFitMode(ApryseSDK.documentViewer.FitMode.FitWidth);
        };

        super({
            Enabled: true,
            Key: key,
            Path,
            Callback: GlobalVariables.registeredCommands[key],
        });
    }
}
